/* Refresh native Liquid cards in Shopify's best-selling collection context. */
(() => {
  function loadPopular(root) {
    if (root.dataset.loaded) return;
    root.dataset.loaded = 'true';
    const url = new URL(window.Shopify.routes.root + 'collections/all', location.origin);
    url.searchParams.set('sort_by', 'best-selling');
    url.searchParams.set('section_id', root.dataset.sectionId);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    fetch(url, { credentials: 'same-origin' })
      .then(response => {
        if (!response.ok) throw new Error('Section unavailable');
        return response.text();
      })
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const grid = parsed.querySelector('[data-popular-grid]');
        if (grid && grid.children.length) {
          root.querySelector('[data-popular-grid]').replaceWith(grid);
          root.dataset.sort = 'best-selling';
        }
      })
      .catch(() => { root.dataset.sort = 'fallback'; });
  }
  function setup() {
    document.querySelectorAll('[data-nba-popular]').forEach(root => {
      if (!('IntersectionObserver' in window)) return loadPopular(root);
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          observer.disconnect();
          loadPopular(root);
        }
      }, { rootMargin: '700px' });
      observer.observe(root);
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
